module.exports = __webpack_public_path__ + "static/media/vs-code-logo.225fbbe0.png";